export default __webpack_public_path__ + "static/media/res-project-2.32cd198f.jpg";